// productTag.utils.js
// (Place this file in a shared 'utils' folder or alongside the new ProductTags component)

/**
 * Predefined colors for tags.
 * Using placeholder colors as requested.
 */
export const PREDEFINED_TAG_BEST_SELLER = 'Best Seller';
// 'Priority Piece' was retired as a tag: it is now MoodboardCategory#primary_piece,
// the PRIORITY badge the designer toggles on the category itself, so it is no
// longer offered in the tag picker.
// export const PREDEFINED_TAG_FINISHING_TOUCH = 'Finishing Touch';
export const PREDEFINED_TAG_BUDGET_CHOICE = 'Budget Friendly';
export const PREDEFINED_TAG_COLORS = {
  // Finishing Touch
  // [PREDEFINED_TAG_FINISHING_TOUCH]: '#F2F2F2',
  [PREDEFINED_TAG_BEST_SELLER]: '#F2F2F2',
  [PREDEFINED_TAG_BUDGET_CHOICE]: '#F2F2F2',
};

/**
 * Parses a tag string (e.g., "Key Item#BGFGFF" or "Key Item")
 * into an object with a name and a color.
 * @param {string} tagString - The tag string from the product.tags array.
 * @returns {{name: string, color: string} | null}
 */
export const parseTag = (tagString) => {
  if (!tagString) {
    return null;
  }

  const parts = tagString.split('#');
  const name = parts[0];

  // Use explicit color if provided, else lookup, else fallback to grey
  const color = parts[1]
    ? `#${parts[1]}`
    : (PREDEFINED_TAG_COLORS[name] || '#B0B0B0'); // Default fallback grey

  return { name, color };
};

/**
 * Tags a product starts with when it is dropped onto a moodboard.
 *
 * Mirrors Design::MoodboardCategoryService#initial_tags: the server applies the
 * budget tag when it creates the moodboard variant, but the drop is rendered
 * optimistically from the search result, so without this the tag would only show
 * up after a reload. `budget_choice` comes from Design::VariantSerializer and
 * already folds in the supplier-level flag.
 *
 * @param {{tags?: string[], budget_choice?: boolean}} product
 * @returns {string[]}
 */
export const initialTags = product => {
  const tags = product.tags || [];
  if (!product.budget_choice) {
    return tags;
  }

  const alreadyTagged = tags.some(tag => {
    const parsed = parseTag(tag);
    return parsed && parsed.name.trim() === PREDEFINED_TAG_BUDGET_CHOICE;
  });

  return alreadyTagged ? tags : [...tags, PREDEFINED_TAG_BUDGET_CHOICE];
};



// WEBPACK FOOTER //
// ./app/javascript/common/utils/productTag.utils.js